export default {
  buildCreate(token) {
    return {
      'data': {
        'attributes': {
          'user-access-token': token,
        },
        'type': 'facebook-integrations',
      },
    };
  },
  async createIntegration(data, axios, token) {
    return await axios.post('/api/facebook/facebook-integrations/', data, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
  }
};
